"use script";

angular.module("core")
.constant("SUPPORT_PHONE_NUMBER", {
    "PRIMARY": "1-514-400-1008",
    "SECONDARY": "1-844-400-1008"
});



//////////////////
// WEBPACK FOOTER
// ./core/company/company.constants.js
// module id = 389
// module chunks = 0